export const WEATHER_DESCRIPTIONS = {
    0: "Clear sky",
    1: "Mainly clear",
    2: "Partly cloudy",
    3: "Overcast",
    45: "Fog and depositing rime fog",
    48: "Fog and depositing rime fog",
    51: "Drizzle: Light intensity",
    53: "Drizzle: Moderate intensity",
    55: "Drizzle: Dense intensity",
    56: "Freezing Drizzle: Light intensity",
    57: "Freezing Drizzle: Dense intensity",
    61: "Rain: Slight intensity",
    63: "Rain: Moderate intensity",
    65: "Rain: Heavy intensity",
    66: "Freezing Rain: Light intensity",
    67: "Freezing Rain: Heavy intensity",
    71: "Snow fall: Slight intensity",
    73: "Snow fall: Moderate intensity",
    75: "Snow fall: Heavy intensity",
    77: "Snow grains",
    80: "Rain showers: Slight intensity",
    81: "Rain showers: Moderate intensity",
    82: "Rain showers: Violent intensity",
    85: "Snow showers: Slight intensity",
    86: "Snow showers: Heavy intensity",
    95: "Thunderstorm: Slight or moderate",
    96: "Thunderstorm with slight hail",
    99: "Thunderstorm with heavy hail",
  };
export const WEATHER_ICONS = {
    0: "sunny.png",
    1: "sunny.png",
    2: "partly-cloudy.gif",
    3: "overcast.png",
    45: "foggy.png",
    48: "foggy.png",
    51: "drizzle.png",
    53: "drizzle.png",
    55: "drizzle.png",
    56: "drizzle.png",
    57: "drizzle.png",
    61: "rainy.png",
    63: "rainy.png",
    65: "rainy.png",
    66: "rainy.png",
    67: "rainy.png",
    71: "snowfall.png",
    73: "snowfall.png",
    75: "snowfall.png",
    77: "snow.png",
    80: "rainy.png",
    81: "rainy.png",
    82: "rainy.png",
    85: "snowfall.png",
    86: "snowfall.png",
    95: "thunderstorm.gif",
    96: "thunderstorm.gif",
    99: "thunderstorm.gif",
  };